<div>
  <div style="text-align:right; margin-bottom:15px;">

    <button
      mat-raised-button
      color="primary"
      class="noPrint"
      printSectionId="print-section"
      ngxPrint>
      Print
    </button>

    <button
      mat-button
      (click)="close()"
      class="noPrint">
      Close
    </button>

  </div>
</div>

<div id="print-section" class="container">

  <table style="width:100%; border-collapse:collapse; border:1px solid #000; text-align:center;">

    <thead>

      <tr>
        <th colspan="7"
            style="border:1px solid #000; padding:10px; font-size:16px; font-weight:bold;">
          जावक अहवाल
        </th>
      </tr>

      <tr>
        <th colspan="7" style="border:1px solid #000; padding:10px;">

          <div style="display:flex; width:100%; align-items:center; font-weight:bold;">

            <div style="width:33%; text-align:left;">&nbsp;</div>

            <div style="width:34%; text-align:center;">
              पुस्तकाचे नाव:
              <span *ngIf="selectedBook; else noBook">
                {{ selectedBook }}
              </span>
              <ng-template #noBook>All Books</ng-template>
            </div>

            <div style="width:33%; text-align:right;">
              Today: {{ todayDate }}
            </div>

          </div>

        </th>
      </tr>

      <tr>
        <th style="border:1px solid #000; padding:8px;">Delivery Mode</th>
        <th style="border:1px solid #000; padding:8px;">Total Book Sellers</th>
         <th style="border:1px solid #000; padding:8px;">Sale copies</th>
        <th style="border:1px solid #000; padding:8px;">Complimentary copies</th>
        <th style="border:1px solid #000; padding:8px;">Sponsor copies</th>
        <th style="border:1px solid #000; padding:8px;">Jyda</th>
        <th style="border:1px solid #000; padding:8px;">Total Copies</th>
        <!-- <th style="border:1px solid #000; padding:8px;">Net Total</th> -->
      </tr>

    </thead>

    <tbody>

      <tr *ngFor="let row of printJavakData; let i = index">

        <td style="border:1px solid #000; padding:6px;">
          {{ row.DeliveryMode }}
        </td>

        <td style="border:1px solid #000; padding:6px;">
          {{ row.total_booksellers }}
        </td>
         <td style="border:1px solid #000; padding:6px;">
         {{ row.normal_copies }}
        </td>

        <td style="border:1px solid #000; padding:6px;">
          {{ row.complimentary_copies }}
        </td>

        <td style="border:1px solid #000; padding:6px;">
          {{ row.sponsor_copies }}
        </td>
         <!-- <td style="border:1px solid #000; padding:6px;">
          {{ row.sponsor_copies }}
        </td> -->

       <td style="border:1px solid #000; padding:6px;">

  <span *ngIf="!row.editing" (click)="row.editing = true">
    {{ row.jyda || 0 }}
  </span>

  <input
    *ngIf="row.editing"
    [(ngModel)]="row.jyda"
    name="jyda{{i}}"
    type="number"
    (keydown.enter)="saveJyda(row, i)"
    (blur)="saveJyda(row, i)"
    style="width:70px;"
  >

</td>

        <!-- <td style="border:1px solid #000; padding:6px;">
          {{ row.total_book_copies }}
        </td> -->

        <!-- FIXED NET CALC -->
        <td style="border:1px solid #000; padding:6px;">
          {{
            (row.normal_copies || 0)
            + (row.jyda || 0)
            +(row.complimentary_copies || 0)
            + (row.sponsor_copies || 0)
          }}
        </td>

      </tr>

      <!-- TOTAL ROW -->
     <tr style="font-weight:bold; background:#fff3cd; border:1px solid #000;">

  <!-- 1 Delivery Mode -->
  <td style="border:1px solid #000;">Total</td>

  <!-- 2 Total Book Sellers -->
  <td style="border:1px solid #000;">
    {{ totalBooksellers }}
  </td>

  <!-- 3 Sale Copies -->
  <td style="border:1px solid #000;">
    {{ totalBookCopies }}
  </td>

  <!-- 4 Complimentary -->
  <td style="border:1px solid #000;">
    {{ totalComplimentaryCopies }}
  </td>

  <!-- 5 Sponsor -->
  <td style="border:1px solid #000;">
    {{ totalSponsorCopies }}
  </td>

  <!-- 6 Jyda -->
  <td style="border:1px solid #000;">
    {{ totalJyda }}
  </td>

  <!-- 7 Total Copies -->
  <td style="border:1px solid #000;">
    {{ grandTotal }}
  </td>

</tr>

    </tbody>

  </table>

</div>